import { Component, OnInit, Inject } from '@angular/core';
import { NgForm } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DocumentoTipoRequisito, EstadoDocumentoItem, SolicitudSeccion } from 'src/app/models/common/enumModel';
import { IConfiguracionDocumentoModel } from 'src/app/models/interfaces/configuracion-documento/IConfiguracionDocumentoModel';
import { DocumentacionRequeridaModel } from 'src/app/models/solicitud/DocumentacionRequeridaModel';
import { EquipoDialogModel, EquipoModel } from 'src/app/models/solicitud/EquipoModel';
import { SolicitudEquipoDocumentosService } from 'src/app/services/solicitud-equipo-documentos/solicitud-equipo-documentos.service';
import { SolicitudEquipoService } from 'src/app/services/solicitud-equipo/solicitud-equipo.service';
import * as fileSaver from 'file-saver';
import { AlertDialogService } from 'src/app/services/alert-dialog/alert-dialog.service';
import { ILogModel } from 'src/app/models/interfaces/ILogModel';
import { VisorPdfDialogComponent } from 'src/app/components/shared/visor-pdf-dialog/visor-pdf-dialog.component';
import { VisorPdfDocumentoModel } from 'src/app/models/common/VisorPdfDocumentoModel';

@Component({
  selector: 'app-registrar-equipo-dialog',
  templateUrl: './registrar-equipo-dialog.component.html',
  styleUrls: ['./registrar-equipo-dialog.component.css']
})
export class RegistrarEquipoDialogComponent implements OnInit {
  displayedColumns: string[] = [
    'nombre',
    'idRequisito',
    'fechaVencimiento',
    'idDocumento',
    'estado',
    'acciones'
  ];
  tipoSeccion: SolicitudSeccion = SolicitudSeccion.Equipos;
  logs: ILogModel[] = [];

  constructor(
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<RegistrarEquipoDialogComponent>,
    private solicitudEquipoService: SolicitudEquipoService,
    private solicitudEquipoDocumentoService: SolicitudEquipoDocumentosService,
    private alertDialogService: AlertDialogService,
    @Inject(MAT_DIALOG_DATA) public data: EquipoDialogModel
  ) {
  }

  ngOnInit(): void {
    // console.log(this.data);
    if (this.data.enableEdit) {
      this.displayedColumns = this.displayedColumns.filter(p => p !== 'estado');
    }

    if (this.data.equipo.idSolicitudEquipo != 0) {
      this.solicitudEquipoService.getById(this.data.equipo.idSolicitud, this.data.equipo.idSolicitudEquipo).subscribe((result) => {
        this.logs = result.logs.filter(p => p.comentarios != "" && p.comentarios != null);;
      });
    }
    this.data.equipo.comentarios = "";
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  addItem(newItem: IConfiguracionDocumentoModel) {
    let element: DocumentacionRequeridaModel | undefined =
      this.data.equipo.documentos.find(
        p =>
          p.idSolicitudDocumentoRequerido === newItem.idSolicitudDocumentoRequerido);
    if (element) {
      element.nombreArchivo = newItem.nombreArchivo;
      element.rutaArchivo = newItem.rutaArchivo;
      element.contieneDocumento = true;
    }
  }

  removeItem(newItem: IConfiguracionDocumentoModel) {
    let element: DocumentacionRequeridaModel | undefined =
      this.data.equipo.documentos.find(
        (p) =>
          p.idSolicitudDocumentoRequerido ===
          newItem.idSolicitudDocumentoRequerido
      );
    if (element) {
      element.nombreArchivo = newItem.nombreArchivo;
      element.contieneDocumento = false;
    }
  }

  onSubmit(form: NgForm) {
    // console.log(this.data.persona.documentos);
    if (!form.invalid) {
      let documentosObligatorios = this.data.equipo.documentos.filter(
        (p) =>
        (
          p.idRequisito == DocumentoTipoRequisito.TODOS &&
          (
            p.contieneDocumento == false ||
            (p.controlarFechas === true && !p.fechaVencimiento)
          )
        )
      );

      if (documentosObligatorios.length > 0) {
        this.alertDialogService.open('Debe ingresar los documentos o fechas de vencimiento obligatorios');
      } else {
        // this.dialogRef.close(this.data);                
        this.solicitudEquipoService.guardar(this.data.equipo).subscribe((result) => {
          console.log(result);
          this.dialogRef.close();
        });
      }
    }
  }

  downloadDocumentFromService(element: DocumentacionRequeridaModel) {
    if (element.permiteVisor) {
      let modelVisor: VisorPdfDocumentoModel = new VisorPdfDocumentoModel();
      modelVisor.seccion = SolicitudSeccion.Equipos;
      modelVisor.idRegistro = this.data.equipo.idSolicitudEquipo;
      modelVisor.idSolicitudDocumento = element.idSolicitudEquipoDocumento;
      modelVisor.codigoSolicitud = this.data.equipo.codigoSolicitud;
      modelVisor.nombreArchivo = element.nombreArchivo;
      const dialogVisroRef = this.dialog.open(VisorPdfDialogComponent, {
        width: '1300px',
        data: modelVisor,
        autoFocus: false,
      });
    }
    else {
      this.solicitudEquipoDocumentoService.downloadDocumento(
        this.data.equipo.codigoSolicitud,
        this.data.equipo.idSolicitudEquipo,
        element.idSolicitudEquipoDocumento
      ).subscribe(data => {
        let blob: any = new Blob([data], { type: 'text/json; charset=utf-8' });
        fileSaver.saveAs(blob, element.nombreArchivo);
      });
    }
  }
}
